module.exports = __webpack_public_path__ + "img/socials_1.f8e92550.png";